import { useEffect } from "react";
import { PageMetaData } from "@/react/components/Layout/PageMetaData";
import { StandardLayoutV2 } from "@/react/components/Layout/StandardLayoutV2";
import { VersionedContent } from "@/react/components/Layout/VersionedContent";
import { Bookmarks } from "@/react/components/Spaces/Bookmarks";
import { SpaceHeaderTitle } from "@/react/components/Spaces/Header/SpaceHeaderTitle";
import { spaceMetaTitle } from "@/react/helpers/spaceHelpers";
import { useIsIframeEmbed } from "@/react/hooks/useIsIframeEmbed";
import { StandardLayoutHeader } from "@circle-react/components/Layout/StandardLayoutV2/StandardLayoutHeader";
import { useCurrentSpaceContext } from "@circle-react/contexts";
import { useAppendBodyClasses } from "@circle-react/hooks/useAppendBodyClasses";
import { useIsLockedSpace } from "@circle-react/hooks/useIsLockedSpace";
import { Portal } from "@circle-react-uikit/Portal";
import { useDynamicLayoutContext } from "../../Layout/DynamicLayout";
import { ManageSpaceActionsV3 } from "../Header/SpaceHeaderActions/ManageSpaceActionsV3";
import { CourseContent } from "./Content";
import { CourseEnrollAction } from "./CourseEnrollAction";
import { CourseHelloBar } from "./Summary/CourseHelloBar";

export const CourseSpace = () => {
  const { data } = useCurrentSpaceContext();
  const space = data;
  const isLockedSpace = useIsLockedSpace();
  const shouldShowBookmarks = !isLockedSpace;
  const isIframeEmbed = useIsIframeEmbed();
  const { setEmptyLayout, setStandardLayout } = useDynamicLayoutContext();

  useAppendBodyClasses(
    `view-space view-space--${space?.id} view-space-in-group view-space-in-group--${space?.space_group_id}`,
  );

  useEffect(() => {
    if (!isIframeEmbed) return;
    setEmptyLayout();
    return setStandardLayout;
  }, [isIframeEmbed, setEmptyLayout, setStandardLayout]);

  if (!space) {
    return null;
  }

  return (
    <VersionedContent fullWidth>
      <PageMetaData title={spaceMetaTitle(space)} />
      <StandardLayoutV2.Breadcrumb />

      <Portal selectorQuery="#standard-layout-header">
        <CourseHelloBar />
        <StandardLayoutHeader
          id="standard-layout-header-child"
          leftContent={<SpaceHeaderTitle space={space} hasDropdown={false} />}
          rightContent={
            <div className="flex gap-4">
              <CourseEnrollAction space={space} />
              <ManageSpaceActionsV3 />
            </div>
          }
          hasBorder
        />
        {shouldShowBookmarks && <Bookmarks />}
      </Portal>
      <CourseContent />
    </VersionedContent>
  );
};

export default CourseSpace;
